/**
 * Comprehensive input protection attributes to prevent third-party extensions
 * from interfering with specific form fields.
 */

export const INPUT_PROTECTION_ATTRIBUTES = {
  // Password Manager Blocking (all valid data attributes)
  "data-lpignore": "true",
  "data-1p-ignore": "true",
  "data-bitwarden-watching": "false",
  "data-form-type": "other",

  // Grammarly Blocking (all valid data attributes)
  "data-gramm": "false",
  "data-gramm_editor": "false",
  "data-enable-grammarly": "false",

  // Standard HTML attributes
  spellCheck: false,
  autoComplete: "off",
} as const;

export type InputProtectionAttributes = typeof INPUT_PROTECTION_ATTRIBUTES;
